import * as React from "react";
import * as Immutable from "immutable";
import { useTranslation } from "react-i18next";
import { ReadOnlyFormGroup } from "components/common";
import SectionComponent from "components/common/Section/SectionComponent";
import EditLinkButton from "./EditLinkButton";
import { STEP_KEY as USER_SYNC_KEY } from "../BackendWizard/UserSyncStep";
const rolesList = (defaultRolesIds, roles, roleNotFound) => {
  const defaultRolesNames = defaultRolesIds.map(
    (roleId) => {
      var _a, _b;
      return (_b = (_a = roles.find((role) => role.id === roleId)) == null ? void 0 : _a.name) != null ? _b : roleNotFound;
    }
  );
  return defaultRolesNames.join(", ");
};
const UserSyncSection = ({ authenticationBackend, roles, excludedFields = {} }) => {
  const { t } = useTranslation("authentication");
  const {
    userSearchBase,
    userSearchPattern,
    userNameAttribute,
    userFullNameAttribute,
    userUniqueIdAttribute,
    emailAttributes
  } = authenticationBackend.config;
  const { defaultRoles = Immutable.List(), defaultUserTimezone } = authenticationBackend;
  return /* @__PURE__ */ React.createElement(
    SectionComponent,
    {
      title: t("user_sync.title"),
      headerActions: /* @__PURE__ */ React.createElement(EditLinkButton, { authenticationBackendId: authenticationBackend.id, stepKey: USER_SYNC_KEY })
    },
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("user_sync.search_base_dn"), value: userSearchBase }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("user_sync.search_pattern"), value: userSearchPattern }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("user_sync.name_attribute"), value: userNameAttribute }),
    /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("user_sync.full_name_attribute"), value: userFullNameAttribute }),
    !excludedFields.emailAttributes && /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("user_sync.email_attribute"), value: emailAttributes.join(",") }),
    !excludedFields.userUniqueIdAttribute && /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: t("user_sync.id_attribute"), value: userUniqueIdAttribute }),
    /* @__PURE__ */ React.createElement(
      ReadOnlyFormGroup,
      {
        label: t("user_sync.default_roles"),
        value: rolesList(defaultRoles, roles, t("user_sync.role_not_found"))
      }
    ),
    /* @__PURE__ */ React.createElement(
      ReadOnlyFormGroup,
      {
        label: t("user_sync.default_user_time_zone"),
        value: defaultUserTimezone || t("user_sync.browser_time_zone")
      }
    )
  );
};
export default UserSyncSection;
